export default __webpack_public_path__ + "static/media/img1Dark.e312017a.png";